export default function PoliticaPrivacidade() {
  const container = document.createElement('div');
  container.className = 'content politicaprivacidade-container';

  // Card de título
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Política de Privacidade - Mobi Light</h2>`;
  container.appendChild(header);

  // Card do conteúdo
  const contentCard = document.createElement('div');
  contentCard.className = 'card';
  contentCard.innerHTML = `
    <p style="font-size:13px;color:#aaa;text-align:left;">
      Atualizado em 15/10/2026 11:17:00 -03
    </p>

    <div style="text-align:left;font-size:14px;color:#ccc;line-height:1.6;">
      <h3>1. Visão geral</h3>
      <p>Esta Política de Privacidade explica como o aplicativo Mobi Light trata informações relacionadas ao uso do aplicativo, ao cadastro de pacientes, ao registro de terapias e à integração com o equipamento Mobi Light.</p>
      <p>O aplicativo foi criado para apoiar profissionais e empresas autorizadas no acompanhamento de pacientes, execução de terapias e sincronização de dados operacionais. O uso do aplicativo deve seguir as orientações técnicas, clínicas e regulatórias aplicáveis ao equipamento e ao serviço contratado.</p>

      <h3>2. Dados que podemos tratar</h3>
      <ul style="margin-left:20px;">
        <li>Dados de conta e acesso, como e-mail, identificadores de usuário, perfil e empresa vinculada.</li>
        <li>Dados de pacientes cadastrados, como nome, peso, data de nascimento, histórico de terapias, sugestões de terapia e registros associados.</li>
        <li>Dados do equipamento Mobi Light, como identificadores, tipo de equipamento, limites, status e informações necessárias para conexão.</li>
        <li>Dados de uso do aplicativo, como eventos de navegação, interações, falhas, logs técnicos e diagnósticos.</li>
        <li>Dados técnicos do dispositivo móvel, como sistema operacional, versão do app, modelo do aparelho, permissões de Bluetooth, rede e dados necessários para diagnóstico.</li>
        <li>Dados de conectividade Bluetooth Low Energy, utilizados para localizar, conectar e enviar comandos ao equipamento Mobi Light.</li>
        <li>Dados de localização quando exigidos pelo sistema operacional para permitir recursos de Bluetooth, especialmente em dispositivos Android.</li>
      </ul>

      <h3>3. Como usamos os dados</h3>
      <p>Usamos os dados para autenticar usuários, sincronizar informações, selecionar pacientes, registrar terapias, conectar o aplicativo ao equipamento Mobi Light por Bluetooth Low Energy, enviar comandos operacionais, melhorar estabilidade e cumprir obrigações legais, regulatórias, contratuais e de segurança.</p>

      <h3>4. Armazenamento local e sincronização</h3>
      <p>O aplicativo pode armazenar dados localmente no dispositivo para permitir funcionamento, consulta e sincronização posterior. Parte das credenciais pode ser armazenada de forma segura pelos mecanismos nativos do aparelho, como Keychain no iOS ou recursos equivalentes no Android.</p>
      <p>Quando houver conexão disponível, o aplicativo pode sincronizar informações com servidores remotos relacionados ao serviço Mobi Light.</p>

      <h3>5. Compartilhamento com terceiros</h3>
      <p>Podemos usar provedores de tecnologia para operar o aplicativo, incluindo serviços de infraestrutura, analytics, distribuição de testes e relatórios de falhas, como Firebase Analytics, Firebase Crashlytics e Firebase App Distribution.</p>
      <p>Também pode haver compartilhamento técnico com sistemas operacionais, lojas de aplicativos, serviços de hospedagem e APIs necessárias para funcionamento do app. Não vendemos dados pessoais.</p>

      <h3>6. Permissões do dispositivo</h3>
      <p>O aplicativo pode solicitar permissões de Bluetooth, localização, rede e outros recursos necessários para funcionamento. A negação dessas permissões pode limitar ou impedir a conexão com o equipamento, a sincronização ou determinados fluxos do aplicativo.</p>

      <h3>7. Dados de saúde e responsabilidade profissional</h3>
      <p>O Mobi Light pode envolver informações relacionadas a pacientes e terapias. Esses dados devem ser tratados por profissionais, empresas ou usuários autorizados, respeitando sigilo, base legal, consentimentos e normas aplicáveis.</p>
      <p>O aplicativo não substitui julgamento clínico, orientação profissional, instruções oficiais do equipamento ou avaliação regulatória.</p>

      <h3>8. Segurança</h3>
      <p>Adotamos medidas técnicas e organizacionais para proteger os dados tratados pelo aplicativo. Ainda assim, nenhum sistema é completamente imune a falhas, uso indevido ou acesso não autorizado.</p>

      <h3>9. Retenção e exclusão</h3>
      <p>Os dados podem ser mantidos enquanto forem necessários para operar o serviço, cumprir obrigações legais, manter histórico operacional, resolver disputas ou atender exigências contratuais. Solicitações de acesso, correção ou exclusão devem ser direcionadas ao suporte.</p>

      <h3>10. Alterações nesta política</h3>
      <p>Esta política pode ser atualizada periodicamente. A data de atualização será indicada no início do documento.</p>

      <h3>11. Contato</h3>
      <p>Para suporte ou solicitações relacionadas à privacidade, acesse Suporte Mobi Light.</p>
    </div>
  `;
  container.appendChild(contentCard);

  return container;
}
